import vm from '../main'

const internals = {}

internals.addReport = function(schedulereport) {
    schedulereport = (({
        reportType,
        reportFrequency,
        scheduleStartDate,
        scheduleEndDate,
        scheduleDay,
        station,
        region,
        generatedBy,
        emailTo,
        emailCc,
        reportGenerationTime,
        status,
        downloadType,
        lastDays,
        vehicleId,allVehicle
    }) => {
        return {
            reportType,
            reportFrequency,
            scheduleStartDate,
            scheduleEndDate,
            scheduleDay,
            station,
            region,
            generatedBy,
            emailTo,
            emailCc,
            reportGenerationTime,
            status,
            downloadType,
            lastDays,
            vehicleId,allVehicle
        }
    })(schedulereport)

    return vm.$schedulereportDataRepository
        .create(schedulereport)
        .then(result => {
            schedulereport = result.data
            return schedulereport
        })
        .catch(error => {
            console.error('schedulereportService.createRegion-error:\n', error)
            throw error
        })
}
internals.updateSchedule = function(schedulereport) {
    schedulereport = Object.assign({}, schedulereport)
        // Filter out properties not needed
    schedulereport = (({
        _id,
        reportType,
        reportFrequency,
        scheduleStartDate,
        scheduleEndDate,
        scheduleDay,
        station,
        region,
        generatedBy,
        emailTo,
        emailCc,
        reportGenerationTime,
        status,
        downloadType,
        lastDays,
        vehicleId,allVehicle
    }) => {
        return {
            _id,
            reportType,
            reportFrequency,
            scheduleStartDate,
            scheduleEndDate,
            scheduleDay,
            station,
            region,
            generatedBy,
            emailTo,
            emailCc,
            reportGenerationTime,
            status,
            downloadType,
            lastDays,
            vehicleId,allVehicle
        }
    })(schedulereport)

    return vm.$schedulereportDataRepository
        .update(schedulereport._id, schedulereport)
        .then(result => {
            schedulereport = result.data
            return schedulereport
        })
        .catch(error => {
            console.error('schedulereportUpdate.update-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/schedulereport.service.js